import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import Flex from 'components/Flex'
export const FooterFlex = styled(Flex)`
  gap: 10px;
`
export const PreviewWrapper = styled.div`
  width: 100%;
  padding: 20px;
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
`
export const SelectClgDiv = styled.div`
  font-style: normal;
  cursor: pointer;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_20};

  background: ${COLORS.GREY_T_95};
  border-radius: 6px;
  padding: 4px 6px;
`
export const CollegeNameDiv = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: ${COLORS.GREY_T_20};
`
export const InvitedClgDiv = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  margin: 20px 0;
`
export const InvitedClgNameDiv = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${COLORS.GREY_T_20};
`
export const CollegeTireDiv = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
`
export const ShortlistFlex = styled(Flex)`
  width: 100%;
  padding: 10px;
  height: 44px;
  background: ${props => (props?.background ? props?.background : '#eff8f4')};
  border-radius: 10px;
  gap: 10px;
`
export const ShortlistDiv = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
`
export const DriveDetailDiv = styled.div`
  margin: 0 0 24px 0;
  padding: 0 0 10px 0;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  line-height: normal;
`
export const DriveModeDiv = styled.div`
  width: 40%;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
`
export const DriveNameDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  width: 60%;
  text-transform: capitalize;
  span {
    margin-left: 10px;
  }
`
export const DriveInfoFlex = styled(Flex)`
  margin: 20px 0;
`
export const DataFlex = styled(Flex)`
  ::after {
    content: ',';
  }
  :last-child:after {
    content: '.';
  }
`
export const PaddingDetails=styled.div`
padding-bottom:40px;
`